import { render, staticRenderFns } from "./PrescriptionSummaryItem.vue?vue&type=template&id=bd713ebc&scoped=true"
import script from "./PrescriptionSummaryItem.vue?vue&type=script&lang=ts"
export * from "./PrescriptionSummaryItem.vue?vue&type=script&lang=ts"
import style0 from "./PrescriptionSummaryItem.vue?vue&type=style&index=0&id=bd713ebc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd713ebc",
  null
  
)

export default component.exports